import React from 'react'
import { TabIconProps } from '../../interfaces/icons'

const HouseIcon = ({ active = false }: TabIconProps) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.3836 15.9841C15.5876 15.9841 16.5676 16.9571 16.5676 18.1531V21.2291C16.5676 21.4861 16.7736 21.6921 17.0376 21.6981H18.9436C20.4456 21.6981 21.6666 20.4921 21.6666 19.0101V10.2861C21.6596 9.77612 21.4166 9.29612 20.9996 8.97712L14.4066 3.71912C13.5216 3.01812 12.2836 3.01812 11.3956 3.72112L4.84763 8.97512C4.41463 9.30412 4.17163 9.78412 4.16663 10.3031V19.0101C4.16663 20.4921 5.38763 21.6981 6.88963 21.6981H8.81363C9.08463 21.6981 9.30463 21.4831 9.30463 21.2191C9.30463 21.1611 9.31163 21.1031 9.32363 21.0481V18.1531C9.32363 16.9641 10.2976 15.9921 11.4926 15.9841H14.3836ZM18.9436 23.1981H17.0196C15.9176 23.1721 15.0676 22.3071 15.0676 21.2291V18.1531C15.0676 17.7841 14.7606 17.4841 14.3836 17.4841H11.4976C11.1286 17.4861 10.8236 17.7871 10.8236 18.1531V21.2191C10.8236 21.2941 10.8136 21.3661 10.7926 21.4341C10.6846 22.4241 9.83863 23.1981 8.81363 23.1981H6.88963C4.56063 23.1981 2.66663 21.3191 2.66663 19.0101V10.2961C2.67663 9.30212 3.13463 8.39212 3.92563 7.79312L10.4606 2.54812C11.8996 1.40812 13.9046 1.40812 15.3406 2.54612L21.9226 7.79612C22.6956 8.38512 23.1536 9.29312 23.1666 10.2751V19.0101C23.1666 21.3191 21.2726 23.1981 18.9436 23.1981Z"
        fill={active ? 'white' : 'black'}
      />
    </svg>
  )
}

export default HouseIcon
